// Decision: see ADR-0004 — the domain number is the one axis resolved at runtime, not baked into the build.
export function domainNumberStrExtractor(hostname: string): string {
  if (hostname.includes('testowaplatforma123.net')) {
    return '';
  }
  const host: string = hostname;
  let version: string = '';
  for (const char of host) {
    if (!isNaN(Number(char))) {
      version += char;
    }
  }
  return version;
}
